/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerFindAllQueryResponse, PotentialChangeOrdersControllerFindAllQueryParams, PotentialChangeOrdersControllerFindAll401, PotentialChangeOrdersControllerFindAll403 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerFindAll";

function getPotentialChangeOrdersControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders` as const }  
  return res
}

/**
 * @summary List potential change orders (scope-filtered)
 * {@link /api/v1/potential-change-orders}
 */
export async function potentialChangeOrdersControllerFindAll(params?: PotentialChangeOrdersControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PotentialChangeOrdersControllerFindAllQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindAll401 | PotentialChangeOrdersControllerFindAll403>, unknown>({ method : "GET", url : getPotentialChangeOrdersControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}